import React, { ChangeEventHandler, ReactNode } from 'react'

interface ICheckBoxProps {
  id: string
  isChecked: boolean
  onChange: ChangeEventHandler<HTMLInputElement>
  additionalClassName?: string
  children: ReactNode
}

export const CheckBox = (props: ICheckBoxProps) => {
  const { id, isChecked, children, additionalClassName, onChange } = props
  const labelClassName = `chk-box__lb ${additionalClassName}`

  return (
    <span className="chk-box tx-chk-box">
      <input
        type="checkbox"
        id={id}
        className="chk-box__ipt"
        checked={isChecked}
        onChange={onChange}
      />
      <label htmlFor={id} className={labelClassName}>
        {children}
      </label>
    </span>
  )
}
